import { SelectionAny } from './internal';
export class SelectionGedcomForm extends SelectionAny {
    getVersion() {
        return this.get("VERS" /* Tag.Version */);
    }
    getName() {
        return this.get("NAME" /* Tag.Name */);
    }
}
//# sourceMappingURL=SelectionGedcomForm.js.map